import React from "react";
import { toast } from "react-toastify";
import NumberFormat from "react-number-format";
import {
  createBasicFile,
  getFileDetail,
  hodApproveFile,
} from "../../actions/FileAction";
import CONSTANT from "../../constant";
import { getCookie } from "../../utils";
import constant from "../../constant";

class HodApproveFile extends React.Component {
  constructor(props) {
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    super(props);
    this.state = {
      userDetail: userDetail,
      fileNumber: {
        name: "fileNumber",
        value: null,
        error: "",
        isRequired: true,
      },
      dated: {
        name: "dated",
        value: null,
        error: "",
        isRequired: true,
      },
      subject: {
        name: "subject",
        value: "",
        error: "",
        isRequired: true,
      },
      financialImplication: {
        name: "financialImplication",
        value: "",
        error: "",
        isRequired: true,
      },
      remarks: {
        name: "remarks",
        value: "",
        error: "",
        isRequired: false, // Make this true if you want it required
      },
      approvalStatus: {
        name: "approvalStatus",
        value: "",
        error: "",
        isRequired: true,
        options: [
          { value: "PENDING", label: "PENDING" },
          { value: "APPROVED", label: "APPROVED" },
          { value: "RETURN", label: "RETURN" },
        ],
      },
      showLoader: false,
      isEditMode: false,
    };
  }

  componentDidMount() {
    this.loadExistingData();
  }

  loadExistingData = async () => {
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    const fileCode = params.get("code");

    if (!fileCode) {
      console.log("No file code provided");
      return;
    }

    this.setState({ showLoader: true });

    try {
      const res = await getFileDetail(fileCode);

      if (res.error) {
        alert(res.error);
        this.setState({ showLoader: false });
        return;
      }

      const detail = res.result?.detail || {};

      this.setState({
        isEditMode: true,
        fileCode: fileCode,
        fileNumber: {
          ...this.state.fileNumber,
          value: detail.fileNumber || null,
        },
        dated: {
          ...this.state.dated,
          value: new Date(detail.dated).toISOString().split("T")[0] || null,
        },
        subject: {
          ...this.state.subject,
          value: detail.subject || "",
        },
        financialImplication: {
          ...this.state.financialImplication,
          value: detail.financialImplication || "",
        },
        remarks: {
          ...this.state.remarks,
          value: detail.remarks || "",
        },
        approvalStatus: {
          ...this.state.approvalStatus,
          value: detail.hodApprovalStatus || "",
        },
        hodAction: {
          ...this.state.hodAction,
          value: detail.hodApprovalStatus || "",
        },
        showLoader: false,
      });
    } catch (err) {
      console.error(err);
      alert("Failed to load file data");
      this.setState({ showLoader: false });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: {
        ...prevState[name],
        value: value,
        error: "",
      },
    }));
  };

  handleDropdownChange = (e) => {
    this.handleChange(e);
  };

  handleRemarksChange = (e) => {
    this.handleChange(e);
  };

  validateStep = () => {
    const { fileNumber, dated, subject, financialImplication, approvalStatus } =
      this.state;
    let isValid = true;

    if (!fileNumber.value || !fileNumber.value.trim()) {
      this.setState((prevState) => ({
        fileNumber: { ...prevState.fileNumber, error: "File # is required" },
      }));
      isValid = false;
    }

    if (!dated.value || !dated.value.trim()) {
      this.setState((prevState) => ({
        dated: { ...prevState.dated, error: "Date is required" },
      }));
      isValid = false;
    }

    if (!subject.value.trim()) {
      this.setState((prevState) => ({
        subject: { ...prevState.subject, error: "Subject is required" },
      }));
      isValid = false;
    }

    if (!financialImplication.value) {
      this.setState((prevState) => ({
        financialImplication: {
          ...prevState.financialImplication,
          error: "Financial implication is required",
        },
      }));
      isValid = false;
    }

    if (!approvalStatus.value) {
      this.setState((prevState) => ({
        approvalStatus: {
          ...prevState.approvalStatus,
          error: "Approval status is required",
        },
      }));
      isValid = false;
    }

    return isValid;
  };

  handleSubmit = async () => {
    if (!this.validateStep()) {
      return;
    }

    this.setState({ showLoader: true });

    const {
      fileNumber,
      dated,
      subject,
      financialImplication,
      remarks,
      approvalStatus,
    } = this.state;
    const model = {
      fileNumber: fileNumber.value,
      dated: dated.value,
      subject: subject.value,
      financialImplication: financialImplication.value || "0",
      remarks: remarks.value, // Add remarks to model
      approvalStatus: approvalStatus.value, // Add approval status to model
      saveAsDraft: true,
      userCode: this.state.userDetail?.code,
    };

    try {
      // Call the API endpoint
      const res = await hodApproveFile(this.state.fileCode, model);

      if (res.status === CONSTANT.static.apiStatus.success) {
        const message = this.props.fileCode
          ? "File updated successfully"
          : "File created successfully";

        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });
        this.props.history.push(constant.component.pendingHodFiles.url);
      } else {
        toast.error(res.error || "Failed to process file", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error processing file. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      this.setState({ showLoader: false });
    }
  };

  render() {
    const {
      fileNumber,
      dated,
      subject,
      financialImplication,
      remarks,
      approvalStatus,
      showLoader,
      isEditMode,
    } = this.state;

    return (
      <div className="card createfilepagebg">
        <div className="card-body">
          <div className="step-content">
            <h5 className="mb-4 fw-semibold">
              {isEditMode
                ? "Update File Information"
                : "Step 1: Basic Information"}
            </h5>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    File # <small className="text-danger">*</small>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      fileNumber.error ? "is-invalid" : ""
                    }`}
                    placeholder="File number"
                    name={fileNumber.name}
                    value={fileNumber.value || ""}
                    onChange={this.handleChange}
                    disabled={isEditMode} // Disable if editing existing file
                  />
                  {fileNumber.error && (
                    <div className="invalid-feedback">{fileNumber.error}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Dated <small className="text-danger">*</small>
                  </label>
                  <input
                    min={new Date().toISOString().split("T")[0]}
                    max={new Date().toISOString().split("T")[0]}
                    disabled={true}
                    type="date"
                    className={`form-control ${
                      dated.error ? "is-invalid" : ""
                    }`}
                    name={dated.name}
                    value={dated.value || ""}
                    onChange={this.handleChange}
                  />
                  {dated.error && (
                    <div className="invalid-feedback">{dated.error}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Subject <small className="text-danger">*</small>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      subject.error ? "is-invalid" : ""
                    }`}
                    placeholder="Subject"
                    name={subject.name}
                    value={subject.value}
                    onChange={this.handleChange}
                  />
                  {subject.error && (
                    <div className="invalid-feedback">{subject.error}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Financial implication{" "}
                    <small className="text-danger">*</small>
                  </label>
                  <NumberFormat
                    decimalScale={2}
                    thousandSeparator={true}
                    allowNegative={false}
                    className={`form-control ${
                      financialImplication.error ? "is-invalid" : ""
                    }`}
                    placeholder="Must be greater than or equal to zero"
                    name={financialImplication.name}
                    value={financialImplication.value}
                    onValueChange={(e) => {
                      this.handleChange({
                        target: {
                          name: financialImplication.name,
                          value: e.value,
                        },
                      });
                    }}
                  />
                  {financialImplication.error && (
                    <div className="invalid-feedback">
                      {financialImplication.error}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Approval Status <small className="text-danger">*</small>
                  </label>
                  <select
                    className={`form-control ${
                      approvalStatus.error ? "is-invalid" : ""
                    }`}
                    name={approvalStatus.name}
                    value={approvalStatus.value}
                    onChange={this.handleDropdownChange}
                  >
                    {approvalStatus.options.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {approvalStatus.error && (
                    <div className="invalid-feedback">
                      {approvalStatus.error}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Remarks{" "}
                    {remarks.isRequired && (
                      <small className="text-danger">*</small>
                    )}
                  </label>
                  <textarea
                    className={`form-control ${
                      remarks.error ? "is-invalid" : ""
                    }`}
                    placeholder="Enter remarks (optional)"
                    name={remarks.name}
                    value={remarks.value}
                    onChange={this.handleRemarksChange}
                    rows="4"
                  />
                  {remarks.error && (
                    <div className="invalid-feedback">{remarks.error}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <button
                  type="button"
                  className="create-btn-next"
                  onClick={this.handleSubmit}
                  disabled={showLoader}
                >
                  {showLoader
                    ? isEditMode
                      ? "Updating..."
                      : "Creating..."
                    : isEditMode
                    ? "Update File"
                    : "Create File & Continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HodApproveFile;
